import { DirectionEnum } from "../../enums";
import { safeParseNumericStringOrUndefined } from "../numbers.helpers";

const parsePositiveDurationMinutes = (value: unknown): number | undefined => {
  const parsed = safeParseNumericStringOrUndefined(value);
  if (parsed === undefined || parsed <= 0) {
    return undefined;
  }
  return parsed;
};

/**
 * Direction-aware max ride duration (minutes). Direction B uses `defaultDurationB` when set and > 0;
 * otherwise (and for A / unknown direction) uses `geoProdMaxDuration`. Unset / 0 → unlimited.
 */
export const getGeoProdMaxDurationMinutesByDirectionFromSystemParams = ({
  systemParams,
  direction,
}: {
  systemParams?: {
    geoProdMaxDuration?: number | string | null;
    defaultDurationB?: number | string | null;
  } | null;
  direction?: DirectionEnum;
}): number | undefined => {
  if (direction === DirectionEnum.DropOff) {
    const durationB = parsePositiveDurationMinutes(
      systemParams?.defaultDurationB,
    );
    if (durationB !== undefined) {
      return durationB;
    }
  }
  return parsePositiveDurationMinutes(systemParams?.geoProdMaxDuration);
};

export const getEffectiveMaxRideDurationMinutes = ({
  priceRateMaxDurationInMinutes,
  systemParams,
  direction,
}: {
  priceRateMaxDurationInMinutes?: number | string | null;
  systemParams?: {
    geoProdMaxDuration?: number | string | null;
    defaultDurationB?: number | string | null;
  } | null;
  direction?: DirectionEnum;
}): number | undefined => {
  const fromRate = parsePositiveDurationMinutes(priceRateMaxDurationInMinutes);
  if (fromRate !== undefined) {
    return fromRate;
  }
  return getGeoProdMaxDurationMinutesByDirectionFromSystemParams({
    systemParams,
    direction,
  });
};
